import { configureStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from "redux-devtools-extension";
import rootSlice from "./coreSlice";

export default configureStore(
  {
    reducer: {
      root: rootSlice,
    },
  },
  composeWithDevTools()
);
